import TableDataSource from './TableDataSource';

export class TsvDataSourceError extends Error {};

/**
 * Assumes that there are no tabs in your data, that the first row is the
 * column names, and that empty cells are null, not the empty string.
 */
export default class TsvDataSource implements TableDataSource {
   
    columns: Map<string, string[]> = new Map();
    readonly length: number;

    constructor(data: string) {
        this.length = this.parse(data);
    }

    parse(data: string) {
        const
            lines = data.split(/\r?\n/),
            // the array is definitely not empty because split at least returns
            // an array with an empty string in it
            namesLine = lines.shift() as string,
            names = namesLine.split('\t'),
            splitLines = lines.map(line => line.split('\t')),
            transposed = new Array(names.length);

        for(let i=0; i < transposed.length; i++) {
            transposed[i] = new Array(splitLines.length);
        }
       
        for(let j=0; j < splitLines.length; j++) {
            const line = splitLines[j];
            if(line.length > transposed.length) {
                throw new TsvDataSourceError(
                    'TsvDataSource.parse found an unlabeled column in the input');
            }
            for(let i=0; i < names.length; i++) {
                transposed[i][j] = line[i];
            }
        }

        for(let i=0; i < names.length; i++) {
            this.columns.set(names[i], transposed[i]);
        }

        return lines.length;
    }

    column(name: string): string[] | undefined {
        return this.columns.get(name);
    }

    cell(name: string, row: number): string | undefined {
        const column = this.columns.get(name);
        if(column) return column[row];
    }

    row(n: number): Record<string, string> | undefined {
        if(n >= this.length) {
            return;
        }

        const record = {};
        for(const col of this.columns.keys()) {
            record[col] = this.columns.get(col)[n];
        }
        return record;
    }
}
